<template>
  <q-dialog
    v-model="showDialog"
    position="left"
    seamless
    @hide="removeClickOutsideListener"
    @show="addClickOutsideListener"
    full-height
    style="z-index: 2001"
  >
    <q-card ref="dialogCard" class="col" bordered style="margin-left: 80px; width: 400px">
      <ModalHeader header="Notifications" :closable="false">
        <SecondaryButton
          dense
          class="q-px-md on-left"
          label="Read All"
          :disable="!groupedNotifications.get('new')"
          @click="readAll"
        />
        <SecondaryButton size="sm" round icon="img:/images/filter.svg">
          <q-menu sanchor="bottom right" self="top middle">
            <q-list>
              <q-item :key="index" v-for="(notificationType, index) in notificationTypes" clickable>
                <q-item-section>
                  <q-checkbox
                    v-model="selectedTypes"
                    :label="getName(notificationType)"
                    :val="notificationType"
                    dense
                  />
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </SecondaryButton>
      </ModalHeader>

      <q-list v-if="groupedNotifications.size > 0" padding>
        <q-item
          class="column"
          v-for="[day, notifications] in groupedNotifications"
          :key="day"
        >
          <q-item-label class="text-weight-medium text-grey-8 text-caption text-uppercase">{{
            getSectionLabel(day)
          }}</q-item-label>
          <div v-for="(notification, index) in notifications" :key="index">
            <Notification
              v-if="selectedTypes.includes(notification.type)"
              :notification="notification"
              @click="
                readNotificiation(notification);
                showDialog = false;
              "
            />
          </div>
        </q-item>
      </q-list>
      <Empty v-else message="No Notifications Yet" />
    </q-card>
  </q-dialog>
</template>

<script setup>
import { ref } from 'vue';

import SecondaryButton from '@/components/brand/SecondaryButton.vue';
import ModalHeader from '@/components/modals/ModalHeader.vue';
import Empty from '@/components/blocks/Empty.vue';
import Notification from './Notification.vue';
import { useNotifications } from '@/hooks/useNotifications';
import { useStore } from 'vuex';
import { getName } from '@/utils/notifications';

const { groupedNotifications, readAll, readNotificiation, getSectionLabel, notificationTypes } =
  useNotifications();

const $store = useStore();

const dialogCard = ref(null);

const selectedTypes = ref($store.getters.notificationsPreferences);

const showDialog = defineModel('showDialog');

const handleClickOutside = (event) => {
  if (showDialog.value && dialogCard.value && !dialogCard.value.$el.contains(event.target)) {
    showDialog.value = false;
  }
};

const addClickOutsideListener = () => {
  document.addEventListener('click', handleClickOutside, { passive: true });
};

const removeClickOutsideListener = () => {
  document.removeEventListener('click', handleClickOutside, { passive: true });
};
</script>

<style lang="scss">
.q-dialog__inner--minimized {
  padding: 0 !important;
}

.dialog .q-dialog__backdrop {
  background-color: transparent;
  background: none;
}
</style>
